module.exports = __webpack_public_path__ + "../resources/img/ic_thunderstorms_weather.70633269.svg";